import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { EventsMutationKeys } from '../../../keys'
import { CreateEventRequest, CreateEventResponse } from '../../../type'
import { createEvent } from '../../services'

export default function useMutationCreateEvent(
	props?: UseBaseMutationOptions<CreateEventResponse, CreateEventRequest>,
) {
	return useMutation({
		mutationKey: [EventsMutationKeys.createEvent],
		mutationFn: (params) => createEvent(params),
		...props,
	})
}
